import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../navigation/navigation.service';
import { HeadBarService } from '../../services/head-bar.service';
import { CurrentUserService } from '../../services/current-user.service';

@Component({
  selector: 'app-head-bar',
  templateUrl: './head-bar.component.html',
  styleUrl: './head-bar.component.scss',
})
export class HeadBarComponent implements AfterViewInit, OnDestroy {
  isScrolled = false;
  private mainElement: HTMLElement | null = null;
  private scrollHandler = () => {
    this.isScrolled = this.mainElement?.scrollTop
      ? this.mainElement.scrollTop > 20
      : false;
  };

  constructor(
    public readonly navigationService: NavigationService,
    public readonly headBarService: HeadBarService,
    public readonly currentUserService: CurrentUserService
  ) {}

  ngAfterViewInit(): void {
    this.mainElement = document.querySelector('main.main');

    if (this.mainElement) {
      this.mainElement.addEventListener('scroll', this.scrollHandler);
    }
  }

  ngOnDestroy(): void {
    if (this.mainElement) {
      this.mainElement.removeEventListener('scroll', this.scrollHandler);
    }
  }
}
